export default __webpack_public_path__ + "static/sparkle-tax-00f1969b837dfb09c438092fcc00c0fd.png";